import { t } from 'i18next';
import AxiosInstance from 'src/shared/services/axios/interceptor';
import { HelpPageModule } from '../models/helpPageModule';

const controller = 'helppage-modules';

// Namnen översätts på det språk som gäller vid anropet. API:ts namn används för en modul som saknar översättning.
export const getAllHelpPageModules = async (): Promise<{ data: HelpPageModule[] }> => {
  const result = await AxiosInstance.get<HelpPageModule[]>(controller);
  return { data: result.data.map((m) => ({ ...m, name: t(`helpArticles:moduleNames.${m.key}`, { defaultValue: m.name }) })) };
};
